rdefine("ag/collections/smallGallery",['backbone','ag/models/galleryModel'],function(Backbone,galleryModel) {

    Backbone.emulateHTTP = true;

    return Backbone.Ribs.Collection.extend({
        group_id: 0,
        model:galleryModel,
        url:'/frontend/api/ajax-gallery',
        comparator:function(item){
            return item.get('order');
        },
        initialize:function(items,options) {
            this.group_id = options.group_id ? options.group_id : 0;
        },
        loadSmall:function() {
            this.fetch({reset:true,data:{small:true,group_id:this.group_id}});
        },
        loadAll: function() {
            this.fetch({reset:true,data:{small:false,group_id:this.group_id}});
        }
    });
});